import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
const Headmistress = () => {
  return (
    <>
      <Header />
      <Breadcrumb
        title="Headmistress’s Message"
        midBreadcrumb="Message"
        mainBreadcrumb="Headmistress’s Message"
      />
      <div className='inner-page message'>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="clearfix">
                <h2 className="mainhead">Headmistress’s Message</h2>
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Headmistress.jpg" className="col-md-5 float-md-end rit-img" alt="Mata Mariam Jan Seva Vidyalay" />
                <p>Education is a powerful weapon that can change the world. At MMJSV Narnaul, we aim to nurture each child’s potential through quality education, strong values and meaningful learning experiences.<br />

                  Our institution is committed not only to maintain high standards of education but also to foster discipline and nurturing an environment where students can learn with confidence and integrity. We aim to equip every learner with the knowledge, skills and values needed to succeed in an ever changing world.<br />

                  We strive to create an environment where curiosity is encouraged, creativity is celebrated and character is shaped with care.<br />

                  With a team of dedicated educators, modern learning facilities and a commitment to continuous improvement, we strive to empower students to become responsible global citizens and innovative thinkers. We help every student grow into a confident, dependable and compassionate individual who reflects integrity, respect and a deep sense of purpose. Through a balanced blend of academics, co-curricular activities and value-based formation, we aim to shape learners who excel intellectually while remaining grounded in faith and moral strength.<br />

                  So together, let us continue to work towards the all-round development and success of our students.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Headmistress